import React from 'react';
import { FormControl, InputAdornment, makeStyles, TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import SortButton from './SortButton';
import UsersDownloadLink from '../UsersDownloadLink';
var useStyles = makeStyles(function () {
    return {
        root: {
            display: 'flex'
        },
        buttonWrapper: {
            justifyContent: 'center'
        },
        downloadWrapper: {
            alignSelf: 'center'
        },
        selectWrapper: {
            minWidth: '200px',
            margin: '0 8px'
        },
        spacer: {
            flex: 1
        }
    };
});
function FilterBar(_a) {
    var filterState = _a.filterState, licenseOptions = _a.licenseOptions, onLicenseChange = _a.onLicenseChange, onSearchChange = _a.onSearchChange, onSortClick = _a.onSortClick, users = _a.users;
    var classes = useStyles();
    var selectAllFilters = filterState.licenseTypes.includes('Select All');
    return (React.createElement("div", { className: classes.root, "data-testid": "lcui-filter-bar" },
        React.createElement(FormControl, null,
            React.createElement(TextField, { "data-testid": "lcui-search-input", onChange: onSearchChange, value: filterState.search, variant: "outlined", InputProps: {
                    startAdornment: (React.createElement(InputAdornment, { position: "start" },
                        React.createElement(SearchIcon, { color: "secondary" })))
                }, placeholder: "Search" })),
        React.createElement(FormControl, { className: classes.buttonWrapper },
            React.createElement(SortButton, { sortDesc: filterState.sortDesc, onClick: onSortClick })),
        React.createElement("div", { className: classes.spacer }),
        React.createElement(FormControl, { className: classes.downloadWrapper },
            React.createElement(UsersDownloadLink, { users: users }))));
}
export default FilterBar;
//# sourceMappingURL=FilterBar.js.map